import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getLocalidades, deleteLocalidad } from "../../../../api/localidad";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";

function getData(localidades) {
  let data = [];
  for (let i = 0; i < localidades.length; ++i) {
    const elem = {};
    elem.name = localidades[i].fullName;
    elem.createdAt = localidades[i].createdAt;
    elem.id = localidades[i]._id;
    data = data.concat(elem);
  }
  return data;
}

export default function LocalidadesPage() {
  const [data, setData] = useState([]);
  const [localidadId, setLocalidadId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  function buttonFormatter(cell) {
    const elem = data.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Editar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-localidad/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(user?.role === "admin" || user.role === "gestor") && (
          <>
            <Tooltip title="Eliminar">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setLocalidadId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "name", text: "Nombre", sort: true },
    {
      dataField: "createdAt",
      text: "Fecha de creación",
      formatter: dateFormatter,
      sort: true,
    },
    {
      dataField: "id",
      text: "",
      formatter: buttonFormatter,
      headerStyle: () => {
        return { width: "110px", textAlign: "center" };
      },
    },
  ];

  useEffect(() => {
    getLocalidades()
      .then((res) => {
        if (res.status === 200) {
          setData(getData(res.data));
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener las localidades.",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Localidades list">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-localidad")}
            >
              Añadir nueva
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table search={true} data={data} columns={columns} />

          <ConfirmDialog
            title={"¿Estás seguro de que quieres eliminar esta localidad?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteLocalidad(localidadId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "¡Eliminada!",
                      customMessage: "Localidad eliminada correctamente.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar la localidad.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
